module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAA9UlEQVR42sWWMQqDQBBFre2tTRWQNFbWOUGCWIXcwsYjeBKPYCdYBG1sLKw9gweITp6kiJDEBHRdGWT+zMPPLrOshhizseCZ//IC474ndBgnCbG58f0u+z1BsqHx9SpB8ARIkFsZXy5TBqne+HYbByqOpwySIi0Fxl0nx6NEkex2EoaSplMGSZEWABjwqit23VfR83h/lGBrb7XvI38G2KrGTSOm+Y8xGPCqKy4Ksax5GABMwVS3rTjON5IWgLLjxMTa9jtGkZbKczwMcjiMo3s+j3N0OpEgKdLa6pKoa6kqHbdTWTJKOoyzTPJcz4qXbLW2X58H+LxlgoMbl4EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ca.png
// module id = 793
// module chunks = 0